<template>
  <div class="auto_1280">
    <div class="contact-us clearfix">
      <div class="fl" v-if="info.data !== undefined">
        <template v-if="lan === 0">
          <div class="title">{{info.data[0].title}}</div>
          <span class="tit1">联系邮箱：<div class="phone">{{info.data[0].email}}</div></span>
          <span class="tit2">联系地址：<div class="addr">{{info.data[0].address}}</div></span>
        </template>
        <template v-else-if="lan === 1">
          <div class="title">{{info.data[1].title}}</div>
          <span class="tit1">Email：<div class="phone">{{info.data[1].email}}</div></span>
          <span class="tit2">Address：<div class="addr">{{info.data[1].address}}</div></span>
        </template>
        <div class="qrcode" v-if="info.data !== undefined">
          <img :src="info.data[0].img3" alt="">
          <pre v-if="lan === 0">{{text}}</pre>
          <pre v-else-if="lan === 1">{{enText}}</pre>
        </div>
      </div>
      <div class="map">
        <!-- <baidu-map id="allmap" @ready="mapReady"></baidu-map> -->
        <img src="@/assets/map.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactUs',
  data () {
    return {
      info: [],
      text: '扫一扫，关注\n唯品会公益公众号',
      enText: 'Please scan, follow\nVipshop public welfare official account',
      lan: this.$store.state.isEn,
      articleTypeId: 20
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  activated () {
    this.init()
  },
  mounted () {
    if (localStorage.getItem('publicInfo') === null) {
      this.$api.post('/api/benefitInfo/queryByParam', { current: 1, pageSize: 2 }, r => {
        this.info = r
      })
    } else {
      try {
        this.info = JSON.parse(localStorage.getItem('publicInfo'))
      } catch (err) {
        console.log(err)
      }
    }
    
    this.init()
  },
  methods: {
    init () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    mapReady ({ BMap, map }) {
      const point = new BMap.Point(this.info.data[0].longitude, this.info.data[0].latitude)
      const info = new BMap.InfoWindow(this.info.data[0].address)
      const size = new BMap.Size(30, 30)
      const icon = new BMap.Icon(require('@/assets/location.png'), size)
      const marker = new BMap.Marker(point, { icon })
      map.centerAndZoom(point, 15)
      map.addOverlay(marker)
      map.enableScrollWheelZoom()
      map.enableContinuousZoom()
      marker.openInfoWindow(info)
      marker.addEventListener('click', function () {
        this.openInfoWindow(info)
      })
    }
  }
}
</script>
<style scoped>
.contact-us{padding: 2% 0 5%;}
.contact-us .fl{float: left; width: 40.625%;}
.contact-us .map{float: right; width: 59.375%;}
.contact-us #allmap{width: 100%; height: 440px;}
.contact-us .title{font-size: 30px; color: #e4007f; padding-bottom: 8%;}
.contact-us .tit2{color: #e4007f; background: url(../../assets/location.png)no-repeat left center; padding-left: 30px;}
.contact-us .tit1{color: #e4007f; background: url(../../assets/phone.png)no-repeat left center; padding-left: 30px;}
.contact-us .phone{font-size: 20px; color: #333; font-family: 'GongfangYa'; padding-top: 10px; padding-bottom: 5%;}
.contact-us .addr{color: #333; padding-top: 10px;}
.contact-us .qrcode{margin-top: 17%;}
.contact-us .qrcode img{border: 1px solid #eee; display: inline-block;}
.contact-us pre{display: inline-block; background: url(../../assets/wechat1.png)no-repeat left top; padding-top: 25px; vertical-align: middle; margin-left: 20px; font-size: 14px; font-weight: lighter; color: #999; line-height: 2;}
@media(max-width: 1200px){
  .contact-us .title{font-size: 26px;}
}
@media(max-width: 768px){
  .contact-us .fl,
 .contact-us .map{float: none; width: 100%;}
 .contact-us .title{padding-bottom: 5%;}
 .contact-us .phone{padding-bottom: 3%;}
 .contact-us .qrcode{margin-top: 5%; margin-block-end: 3%;}
 .contact-us #allmap{height: 300px;}
}
</style>
